import Pagination from 'react-bootstrap/Pagination';

const CustomPagination = ({ totalPages, currentPage, onPageChange }) => {
    if (totalPages <= 1) return null;
    const items = [];
    //const ellipsisThreshold = 3;
    const ellipsisThreshold = 2;

    for (let i = 1; i <= totalPages; i++) {
        if (
            i === 1 || // Always show the first page
            i === totalPages || // Always show the last page
            (i >= currentPage - ellipsisThreshold && i <= currentPage + ellipsisThreshold) // Show pages near the current page
        ) {
            items.push(
                <Pagination.Item
                    key={i}
                    active={i === currentPage}
                    onClick={() => onPageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        } else if (
            (i === currentPage - ellipsisThreshold - 1 || i === currentPage + ellipsisThreshold + 1) &&
            i !== 1 &&
            i !== totalPages
        ) {
            items.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
        }
    }

    return (
        // <Pagination>
        //     <Pagination.Prev
        //         onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        //         disabled={currentPage === 1}
        //     />
        //     {items}
        //     <Pagination.Next
        //         onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        //         disabled={currentPage === totalPages}
        //     />
        // </Pagination>

        <Pagination>
            {currentPage > 1 && (
                <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} />
            )}
            {items}
            {currentPage < totalPages && (
                <Pagination.Next onClick={() => onPageChange(currentPage + 1)} />
            )}
        </Pagination>
    );
};

export default CustomPagination;